import styled from "styled-components";
import Sheet from "react-modal-sheet";
import Box from "@mui/material/Box";

const PopupsSheetHeader = styled(Sheet.Header)`
   {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    visibility: visible;
    background-color: ${(props) => props.theme.color.background.primary};
    color: ${(props) => props.theme.color.background.primary};
    right: 0;
    left: 0;
  }
`;

const Container = styled.div`
  background-color: ${(props) => props.theme.color.background.primary};
  color: ${(props) => props.theme.color.background.primary};
  height: 68px;
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ContentContainer = styled(Box)({
  paddingLeft: "16px",
  paddingRight: "16px",
  paddingBottom: "16px",
  overflow: "auto",
  height: "100%",
  color: (props) => props.theme.color.background.primary,
  backgroundColor: (props) => props.theme.color.background.primary,
});

const Puller = styled.div`
  width: 24px;
  height: 2px;
  background-color: ${(props) => props.theme.color.text.primary};
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: calc(50% - 12px);
`;

const Title = styled.div`
  font-weight: 600;
  text-align: start;
  font-size: 16px;
  color: ${(props) => props.theme.color.text.primary};
`;

const SheetState = styled.div`
  font-weight: 400;
  text-align: start;
  font-size: 12px;
  color: ${(props) => props.theme.color.accent};
`;

const Spacer = styled.div`
  width: auto;
  margin-left: 16px;
  margin-right: 16px;
  border-top: 1px solid #7f7f86;
  opacity: 12%;
`;

const ContentSheet = styled(Sheet)`
  .react-modal-sheet-container {
    background-color: ${(props) => props.theme.color.background.primary} !important;
  }
  .react-modal-sheet-backdrop {
    background-color: ${(props) => props.theme.color.background.primary} !important;
  }
  .react-modal-sheet-drag-indicator {
    background-color: ${(props) => props.theme.color.background.light} !important;
  }
`;

export { ContentSheet, PopupsSheetHeader, Container, Puller, Title, SheetState, ContentContainer, Spacer };
